import * as React from "react";
import Svg, { G, Circle, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function SvgComponent(props) {
  return (
    <Svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G filter="url(#filter0_d_9465_1194)">
        <Circle cx={20} cy={18} r={16} fill="#fff" />
      </G>
      <Path stroke="#000" d="M12.5 10.5H18.5V16.5H12.5z" />
      <Path stroke="#000" d="M12.5 19.5H18.5V25.5H12.5z" />
      <Path stroke="#000" d="M21.5 10.5H27.5V16.5H21.5z" />
      <Path stroke="#000" d="M21.5 19.5H27.5V25.5H21.5z" />
      <Path
        d="M21 10l8 8M29 10l-8 8"
        stroke="#FF2E00"
        strokeWidth={2.2}
        strokeLinecap="round"
      />
      <Defs />
    </Svg>
  );
}

export default SvgComponent;
